import { RoleMemberType } from "./RoleMemberType"

export const RoleMemberTypeDisplayName: Record<RoleMemberType, string> = {
    [RoleMemberType.FoundationApiResource]: "API Resource",
    [RoleMemberType.MyKonicaMinoltaApplicationEntity]: "MKM Application Entity",
    [RoleMemberType.MyKonicaMinoltaApplicationGroup]: "MKM Application Group",
    [RoleMemberType.MyKonicaMinoltaJobCode]: "MKM Job Code",
    [RoleMemberType.MyKonicaMinoltaPerson]: "MKM Person",
    [RoleMemberType.MyKmbsPerson]: "MyKMBS Person"
};